import classNames from 'classnames';

type ScrollListProps = {
  children: React.ReactNode;
  className?: string;
  height?: 'small' | 'medium' | 'large';
};

export const ScrollList: React.FC<ScrollListProps> = ({
  children,
  className,
  height = 'large',
}) => (
  <div
    className={classNames('relative overflow-y-scroll scrollbar', className, {
      'h-[400px]': height === 'large',
      'h-[300px]': height === 'medium',
      'h-[200px]': height === 'small',
    })}
  >
    {children}
  </div>
);
